import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {MultiSelect} from '../../../../../ui/components/common/MultiSelect';
import {IElement} from '../../../../../incase-domain/elements';
import Label from '../../../../../incase-domain/components/label/Label';

interface ElementsToClickBeforeDisplayProps {
    slideElementOptions: {
        label: string;
        value: string;
    }[];
    elementToClickForDisplay: string[];
    highlightedElementChangeHandler: {single: (field: keyof IElement, value: unknown) => void};
    disabled?: boolean;
}

function ElementsToClickBeforeDisplay(props: ElementsToClickBeforeDisplayProps): ReactElement {
    const {slideElementOptions, elementToClickForDisplay, highlightedElementChangeHandler, disabled = false} = props;
    const {t} = useTranslation();

    function mapSelectedOptions(options: string[]): {label: string; value: string}[] {
        const resOptions: {label: string; value: string}[] = [];

        options.forEach((option) => {
            const item = slideElementOptions.find((item) => item.value === option);

            if (item) resOptions.push(item);
        });

        return resOptions;
    }

    return (
        <div>
            <Label>{t('designSidepanel.elementsToClickBeforeDisplay')}</Label>
            <MultiSelect
                disabled={disabled}
                options={slideElementOptions.filter((element) => !element.label.includes('Modal'))}
                value={mapSelectedOptions(elementToClickForDisplay)}
                onChange={(e) => {
                    if (e)
                        highlightedElementChangeHandler.single(
                            'elementToClickForDisplay',
                            e.map((item) => item.value)
                        );
                }}
            />
        </div>
    );
}

export default ElementsToClickBeforeDisplay;
